import React from 'react';
import { IconProps } from '.';

const SvgRocket = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M17.75 3.778c-1.62.14-3.906.868-6.39 3.353-1.929 1.928-3.105 4.056-3.833 5.932a1.11 1.11 0 0 0 .269 1.17l.408.41 2.048-2.048 1.06 1.06-2.047 2.048.502.502a1.11 1.11 0 0 0 1.17.268 16.915 16.915 0 0 0 5.932-3.833c2.485-2.484 3.213-4.77 3.353-6.39a6.778 6.778 0 0 0-.099-1.932 5.143 5.143 0 0 0-.085-.356 5.099 5.099 0 0 0-.356-.086 6.78 6.78 0 0 0-1.933-.098Zm2.88-.408.298-.689.273.118.118.273-.689.298Zm-.69.295v-.002.002Zm-9.851 14.33a2.635 2.635 0 0 1-1.383-.73l-.502-.501-1.299 1.299-1.06-1.061 1.299-1.3-.41-.408a2.635 2.635 0 0 1-.73-1.383l-4.863-2.093L8.16 8.65a18.055 18.055 0 0 1 2.14-2.58c2.727-2.728 5.341-3.615 7.32-3.787a8.277 8.277 0 0 1 2.362.124 6.216 6.216 0 0 1 .862.24c.022.01.041.017.055.022l.018.008.006.002.003.001c.001.001.002.001-.296.69.689-.298.689-.297.69-.297v.004l.003.006.008.018.021.055c.018.046.04.11.067.19.051.16.116.387.174.672.117.572.209 1.381.124 2.362-.172 1.979-1.059 4.593-3.787 7.32a18.163 18.163 0 0 1-2.582 2.145l-3.166 7.014-2.093-4.863Zm1.579-.125.547 1.27.869-1.924c-.461.235-.933.453-1.416.654Zm-4.884-6.954-1.925.87 1.271.546c.2-.483.418-.955.654-1.416Zm6.79-4.178c1.013-1.014 2.666-1 3.677.01 1.012 1.012 1.025 2.665.011 3.679-1.014 1.013-2.666 1-3.678-.011-1.011-1.012-1.024-2.664-.01-3.678Zm2.617 1.071a1.106 1.106 0 0 0-1.557-.01c-.42.42-.423 1.122.011 1.556.434.434 1.137.43 1.556.011.42-.42.424-1.122-.01-1.557Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgRocket;
